/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button, Card, FormControl, Tooltip, Typography } from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import { attributesNames, colorTypes } from '../../../constants'
// import { Logger, LoggerTypes } from '../../../utils'
import { truncate } from '../../../utils'
import { Icon, iconNames } from '../../../components'
import './style.scss'

/**
 * Display the condition Card
 *
 * @param {object} currentCheck  Ex: { left_operand: {}, operator: '>', right_operand: {} }
 * @returns {Dialog}
 */
const SimulationConditionCard = ({ currentCheck, onDelete }) => {
  const { t } = useTranslation()

  // -- left_operand
  // const left_operand_icon =
  //   currentCheck?.left_operand?.attributesName === attributesNames.RESOURCES
  //     ? iconNames.RESOURCE
  //     : currentCheck?.left_operand?.attributesName === attributesNames.VARIABLES
  //     ? iconNames.VARIABLE
  //     : currentCheck?.left_operand?.attributesName === attributesNames.PARAMETERS
  //     ? iconNames.PARAMETER
  //     : iconNames.CUSTOM

  const left_operand_name = currentCheck?.left_operand?.attribute?.name || 'N/A'

  // const left_operand_value =
  //   currentCheck?.left_operand?.attribute?.quantity ||
  //   currentCheck?.left_operand?.attribute?.initial_value ||
  //   currentCheck?.left_operand?.attribute?.value ||
  //   currentCheck?.left_operand?.attribute?.right_operand_value ||
  //   null

  // const left_operand_unit = currentCheck?.left_operand?.attribute?.unit || null

  // -- right_operand
  const right_operand_icon =
    currentCheck?.right_operand?.attributesName === attributesNames.RESOURCES
      ? iconNames.RESOURCE
      : currentCheck?.right_operand?.attributesName === attributesNames.VARIABLES
      ? iconNames.VARIABLE
      : currentCheck?.right_operand?.attributesName === attributesNames.PARAMETERS
      ? iconNames.PARAMETER
      : iconNames.CUSTOM

  const right_operand_name =
    currentCheck?.right_operand?.attribute?.name ||
    (currentCheck?.right_operand_value ? t('simulations.launch.while_conditions.custom') : null) ||
    null

  const right_operand_value =
    currentCheck?.right_operand?.value ||
    currentCheck?.right_operand?.attribute?.quantity ||
    currentCheck?.right_operand?.attribute?.initial_value ||
    currentCheck?.right_operand?.attribute?.value ||
    currentCheck?.right_operand_value ||
    null

  const right_operand_unit = currentCheck?.right_operand?.attribute?.unit || null

  const maxLen = 14

  // Logger.trace(LoggerTypes.CONTAINER, 'SimulationConditionCard.render()', {
  //   currentCheck,
  //   left_operand: {
  //     name: left_operand_name,
  //     value: left_operand_value,
  //     unit: left_operand_unit
  //   },
  //   right_operand: {
  //     name: right_operand_name,
  //     value: right_operand_value,
  //     unit: right_operand_unit
  //   }
  // })

  return (
    <Card className="SimulationConditionCard common-card">
      <FormControl>
        <div>
          <div className="mainC">
            <div className="leftC">
              {/* -- Left Operand -- */}
              {left_operand_name && left_operand_name.length > maxLen ? (
                <Tooltip title={left_operand_name}>
                  <Typography className="operand" color={colorTypes.PRIMARY}>
                    {truncate(left_operand_name, maxLen)}
                  </Typography>
                </Tooltip>
              ) : (
                <Typography className="operand" color={colorTypes.PRIMARY}>
                  <span className="name">{left_operand_name}</span>
                </Typography>
              )}

              {/* -- Operator -- */}
              <Typography className="operator" color={colorTypes.PRIMARY}>
                {`${String(currentCheck?.operator || '')}`}
              </Typography>

              {/* -- Right Operand -- */}
              {right_operand_name && right_operand_name.length > maxLen ? (
                <Tooltip title={right_operand_name}>
                  <Typography className="operand" color={colorTypes.PRIMARY}>
                    <span className="name">{truncate(right_operand_name, maxLen)}</span>
                    <span className="value">
                      <Icon name={right_operand_icon} size={12} className="icon" />
                      {t('flowActions.conditions.card.value')} {right_operand_value} {right_operand_unit}
                    </span>
                  </Typography>
                </Tooltip>
              ) : (
                <Typography className="operand" color={colorTypes.PRIMARY}>
                  <span className="name">{right_operand_name}</span>
                  <span className="value">
                    <Icon name={right_operand_icon} size={12} className="icon" />
                    {t('flowActions.conditions.card.value')} {right_operand_value} {right_operand_unit}
                  </span>
                </Typography>
              )}
            </div>
            <div className="rightC">
              {onDelete && (
                <Tooltip title={t('common.delete')}>
                  <Button onClick={onDelete} className="btDelete" color="primary">
                    <DeleteOutlineIcon fontSize="small" />
                  </Button>
                </Tooltip>
              )}
            </div>
          </div>
        </div>
      </FormControl>
    </Card>
  )
}

SimulationConditionCard.displayName = 'SimulationConditionCard'

SimulationConditionCard.propTypes = {
  currentCheck: PropTypes.object.isRequired,
  onDelete: PropTypes.func
}

SimulationConditionCard.defaultProps = {
  currentCheck: null, // e.g: {id: 'xx-UUID-xx', operation: 'plus', quantity}
  onDelete: null
}

export default memo(SimulationConditionCard)
